module.exports = __webpack_public_path__ + "img/jpg.85b50cc7.svg";